import React      from 'react'
import PropTypes  from 'prop-types'
import classNames from 'classnames'
import TrashIco   from 'images/products/project_quote/trash-ico.svg'

// eslint-disable-next-line react/prop-types
const Edit = ({ showEdit, onEdit }) => {
  if (!showEdit) {
    return null;
  }

  return (
    <button
      type="button"
      className="btn btn-link bundle-item-action edit-item"
      onClick={() => onEdit()}>
      EDIT
    </button>
  )
}

// eslint-disable-next-line react/prop-types
const Delete = ({ showDelete, onDelete }) => {
  if (!showDelete) {
    return null;
  }

  return (
    <button
      type="button"
      className="btn btn-link px-0 bundle-item-action remove-item"
      onClick={() => onDelete()}>
      <img src={TrashIco} alt="delete" className="trash-ico" />
    </button>
  )
}

const BundleItemWrap = ({
  name,
  showEdit,
  showDelete,
  onEdit,
  onDelete,
  children,
  contentClassName,
}) => (
  <div className="bundle-item" id={name.replace(" ", "-").toLowerCase()}>
    <div className="bundle-item-head">
      <div className="bundle-item-actions float-end">
        <Edit showEdit={showEdit} onEdit={onEdit} />
        <Delete showDelete={showDelete} onDelete={onDelete} />
      </div>
      <div className="bundle-item-name">
        {name}
        {showEdit ? (<span className="summary-label"> SUMMARY </span>) : ''}
      </div>
    </div>

    <div className={classNames('bundle-item-content', contentClassName)}>
      {children}
    </div>
  </div>
)

BundleItemWrap.defaultProps = {
  onEdit: null,
  onDelete: null,
  children: null,
}

BundleItemWrap.propTypes = {
  name: PropTypes.string.isRequired,
  showEdit: PropTypes.bool.isRequired,
  showDelete: PropTypes.bool.isRequired,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
  children: PropTypes.element,
  contentClassName: PropTypes.object,
}

export default BundleItemWrap
